<template>
  <Modal :footer-hide="true" :mask-closable="false" v-model="show" :title="title" :width="1000" @on-cancel="clearFrom" @on-ok="clearFrom">
    <table class="QHtable" v-if="show">
      <tr>
        <th style="width: 150px">基本信息</th>
        <th colspan="10">
          <Button type="primary" @click="$refs.OSgovShipUpdate.hiPop(row)" style="float: right" title="信息修改"> 信息修改 </Button>
        </th>
      </tr>
      <tr>
        <td><b>船舶编号</b></td>
        <td>{{ row.shipCode }}</td>
        <td style="width: 150px; text-align: center"><b>平台号码</b></td>
        <td>{{ row.name }}</td>
      </tr>
      <tr>
        <td><b>船舶载量</b></td>
        <td>{{ row.capacity }}</td>
        <td style="text-align: center"><b>船舶登记号</b></td>
        <td>{{ row.registrationNumber }}</td>
      </tr>
      <tr>
        <td><b>船检登记号</b></td>
        <td>{{ row.inspectionRegistrationNumber }}</td>
        <td style="text-align: center"><b>船属企业</b></td>
        <td>{{ row.owner }}</td>
      </tr>

      <tr>
        <td><b>经营许可证号码</b></td>
        <td>{{ row.licenseNumber }}</td>
        <td style="text-align: center"><b>注册SIM号</b></td>
        <td>{{ row.registerNumber }}</td>
      </tr>
      <tr>
        <td><b>年审起始时间</b></td>
        <td>{{ $timeFmt(row.validityPeriodstart, "YYYY-MM-DD") }}</td>
        <td style="text-align: center"><b>年审终止时间</b></td>
        <td>{{ $timeFmt(row.validityPeriodend, "YYYY-MM-DD") }}</td>
      </tr>

      <tr>
        <td><b>检验状态</b></td>
        <td>
          <span v-if="row.teststatus == 100">未检验</span>
          <span v-if="row.teststatus == 200">已检验</span>
        </td>
        <td style="text-align: center"><b>注销状态</b></td>
        <td>
          <span v-if="row.cancelstatue == 100">未注销</span>
          <span v-if="row.cancelstatue == 200">已注销</span>
        </td>
      </tr>
      <tr>
        <td><b>过期状态</b></td>
        <td>
          <span v-if="row.expirestatus == 100">未过期</span>
          <span v-if="row.expirestatus == 200">已过期</span>
        </td>
        <td style="text-align: center"><b>船舶状态</b></td>
        <td>
          <span v-if="row.status == 100">使用中</span>
          <span v-if="row.status == 200">未使用</span>
        </td>
      </tr>
      <!-- 资质证件部分保持不变 -->
      <tr>
        <th>资质证件</th>
        <th colspan="10">
          <QHButton A="A222" size="default" style="float: right" @Tap="$refs.setQualification.hiCreated(row.id, 700)" v-if="isAuth"> 资质上传 </QHButton>
        </th>
      </tr>
      <tr v-if="!row.information700">
        <td colspan="10">暂无证件资质信息</td>
      </tr>
      <tr v-for="(item, index) in row.information700" :key="index">
        <td>
          <b>{{ $s("zizhiTypeTxt", item.zizhiType) || "其他资质" }}</b>
        </td>
        <td colspan="10">
          <div class="flex-between">
            <div>
              <span class="MR5 CL4" v-if="$isYouxiaoqiNei(item.startTime, item.endTime)"><i class="MR3 iconfont icon-tongyi"></i>有效期内</span>
              <span class="MR5 CL6" v-else><i class="MR3 iconfont icon-wenhao-quan"></i>有效期外</span>
              <span>{{ item.name }}</span>
              <span style="white-space: nowrap">(有效期{{ $timeFmt(item.startTime, "YYYY年MM月DD日") }}至{{ $timeFmt(item.endTime, "YYYY年MM月DD日") }})</span>
            </div>
            <div class="flex-between" style="margin-left: 10px">
              <span class="QHset" style="white-space: nowrap" @click="$refs.setQualification.hiUpdete(item.id)" v-if="isAuth"> 修改 </span>
              <span class="QHset" style="white-space: nowrap" @click="$openImg($getFritImg(item.url))"> 查看 </span>
              <span class="QHset CL1" style="white-space: nowrap" @click="deleteData(item.id)" v-if="isAuth"> 删除 </span>
            </div>
          </div>
        </td>
      </tr>

      <!--审核日志-->
      <tr>
        <th colspan="10"  style="text-align:left;">年审时间修改记录</th>
      </tr>
      <tr v-if="$isblank(row.log)">
        <td colspan="10">暂无修改记录</td>
      </tr>
      <tr v-if="!$isblank(row.log)"> 
        <td colspan="10">
          <div style="text-align:left;padding:5px;border-radius:5px;margin:5px 0;background:#f5f5f5;" v-for="(item, index) in row.log" :key="index">
            <p>{{$timeFmt(item.created, "YYYY年MM月DD日 HH:mm")}}➥行政单位:{{item.orgName}}➥账号:{{item.username}}➥通过:{{item.app}}</p>
            <p>{{item.content}}</p>
          </div>
        </td>
      </tr>
      <!---审核日志 end-->
    </table>



    <OSgovShipUpdate ref="OSgovShipUpdate" @success="reDetailed()"></OSgovShipUpdate>
  </Modal>
</template>
<script>
import OSgovShipUpdate from "@/component/OSgovShipUpdate/OSgovShipUpdate.vue";
export default {
  components: { OSgovShipUpdate },
  // +----------------------------------------------------------------------
  // | Desc:data
  // +----------------------------------------------------------------------
  data() {
    return {
      title: "船舶详情",
      show: false,
      isAuth: false,
      isUpdate: false,
      row: {},
    };
  },
  methods: {
    // +----------------------------------------------------------------------
    // | Desc:修改后刷新
    // +----------------------------------------------------------------------
    reDetailed() {
      this.isUpdate = true;
      this.hiPop(this.row, this.isAuth);
    },

    // +----------------------------------------------------------------------
    // | Desc:清理表单
    // +----------------------------------------------------------------------
    clearFrom() {
      if (this.isUpdate) {
        this.$emit("success");
      }
      this.show = false;
      this.title = "船舶详情";
      this.isAuth = false;
      this.isUpdate = false;
      this.row = {};
    },

    // +----------------------------------------------------------------------
    // | Desc:查询详情
    // +----------------------------------------------------------------------
    hiPop(e, isAuth) {
      this.isAuth = isAuth;
      this.$loading(true);
      this.$api.getShipDetailed({ id: e.id }).then((res) => {
        this.$loading(false);
        if (res.code == 0) {
          this.row = res.data;
          this.show = true;
        } else {
          this.$msg(res.msg, "error");
        }
      });
    },
    // +----------------------------------------------------------------------
    // | Desc:删除资质
    // +----------------------------------------------------------------------
    deleteData(id) {
      //请求入库
      var that = this;
      var confirm = {
        title: "删除资质",
        msg: "<p>一旦删除就不可撤销，只能重新上传！</p>",
      };
      this.$confirm(confirm, function () {
        //参数整合与接口
        var https = {
          isLoading: "isLoadingPop",
          api: that.$api.removeShipQualification,
          parameter: {
            id: id,
          },
          successMsg: "删除成功",
        };
        that.$httpsApi(
          https,
          function (res) {
            that.hiPop(that.row, that.isAuth);
            that.$emit("success");
          },
          function (res) {
            that.$alert(res.msg);
          }
        );
      });
    },
  },
};
</script>
